import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export function useVisitorTracking() {
  const location = useLocation();
  const lastTrackedPath = useRef("");

  useEffect(() => {
    // Check for granular analytics consent
    const cookiePreferences = localStorage.getItem("cookie_preferences");
    let analyticsEnabled = false;
    
    if (cookiePreferences) {
      try {
        const prefs = JSON.parse(cookiePreferences);
        analyticsEnabled = prefs.analytics === true;
      } catch (e) {
        analyticsEnabled = false;
      }
    }
    
    // Only track if analytics consent was given
    if (!analyticsEnabled) return;

    // Don't track the same page twice in a row
    if (location.pathname === lastTrackedPath.current) return;
    lastTrackedPath.current = location.pathname;

    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/tracking/event`, {
          event_type: "page_view",
          page_url: location.pathname,
          referrer: document.referrer || null,
          metadata: {
            search: location.search,
            title: document.title
          }
        });
      } catch (error) {
        // Silently fail - tracking should not break the app
        console.debug("Tracking error:", error.message);
      }
    };

    trackPageView();
  }, [location]);
}

export default useVisitorTracking;
